import request from '@/api/request.js'

// 新增
export function QuestionCategoryInsert(data) {
    return request({
        url: '/api/question/questioncategoryinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function QuestionCategoryDelete(id) {
    return request({
        url: `/api/question/questioncategorydelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function QuestionCategoryUpdate(id, data) {
    return request({
        url: `/api/question/questioncategoryupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function QuestionCategoryGetById(id) {
    return request({
        url: `/api/question/getquestioncategorybyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function QuestionCategoryGetList(params) {
    return request({
        url: '/api/question/getquestioncategorylist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function QuestionCategoryGetPageList(params) {
    return request({
        url: '/api/question/getquestioncategorypagelist',
        method: 'get',
        params: params
    })
}